import { Tariff } from 'reactApp/types/Billing';

export interface Props {
    file?: IFile;
    files?: IFiles;
    numberOfFiles: number;
    onClose: () => void;
    continueFileLoading: () => void;
    skipFileLoading: () => void;
    showProTariff: boolean;
}

export interface Subscription {
    trialSubscription: Tariff;
    uploadLimit: number;
    showTariffType: EShowTariffType;
    showProTariff: boolean;
}

export interface Content {
    header: string;
    annotation: JSX.Element;
    actions: JSX.Element;
}

export enum EShowTariffType {
    PRO = 'pro',
    USUAL_TARIFF = 'usual_tariff',
    TRIAL = 'trial',
}

interface IFile {
    extension: string;
    name: string;
    size: string;
    sizeBytes: number;
}

interface IFiles {
    size: string;
    number: number;
    sizeBytes: number;
}

export interface IBigFileModalContent {
    subscription: Subscription;
    numberOfFiles: number;
    callbacks: IModalCallbacks;
    files?: IFiles;
    file?: IFile;
}

export interface IModalCallbacks {
    onSkip: () => void;
    onRequestPayment: () => void;
    onClose: () => void;
}
